import ApplicationSerializer from './application';

export default class MailerSectionBlockSerializer extends ApplicationSerializer {
  attrs = {
    overrides: 'mailer-section-block-overrides',
  };
}
